import CommonList from "@/components/common/List";
import CommonTableList from "@/components/common/TableList";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ColumnDef } from "@tanstack/react-table";
import { MoreVerticalIcon } from "lucide-react";
import React, { useEffect, useState } from "react";
import ClientEdit from "./Edit";
import ClientCreate from "./Create";
import ClientDelete from "./Delete";
import ClientImport from "./Import";
import { ResourceContextProvider } from "react-admin";

const AutoClientsList = () => {
  const columns = React.useMemo<ColumnDef<any>[]>(
    () => [
      {
        id: "select",
        header: ({ table }) => (
          <Checkbox
            checked={
              table.getIsAllPageRowsSelected() ||
              (table.getIsSomePageRowsSelected() && "indeterminate")
            }
            onCheckedChange={(value) =>
              table.toggleAllPageRowsSelected(!!value)
            }
            aria-label="Select all"
          />
        ),
        cell: ({ row }) => (
          <Checkbox
            checked={row.getIsSelected()}
            onCheckedChange={(value) => row.toggleSelected(!!value)}
            aria-label="Select row"
          />
        ),
        enableSorting: false,
        enableHiding: false,
      },
      {
        accessorKey: "id",
        header: "ID",
        cell: ({ row }) => (
          <div className="capitalize">{row.getValue("id")}</div>
        ),
      },
      {
        accessorKey: "name",
        header: "Name",
        cell: ({ row }) => {
          return (
            <div className="flex flex-col text-sm space-y-1">
              <span className="font-medium">{row.getValue("name")}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "email",
        header: "Email",
        cell: ({ row }) => {
          return (
            <div className="flex flex-col text-sm space-y-1">
              <span className="font-medium">{row.getValue("email")}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "phone",
        header: "Phone number",
        cell: ({ row }) => {
          return (
            <div className="flex flex-col text-sm space-y-1">
              <span className="font-medium">{row.getValue("phone")}</span>
            </div>
          );
        },
      },
      {
        id: "actions",
        cell: ({ row }) => (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                className="flex size-8 text-muted-foreground data-[state=open]:bg-muted"
                size="icon"
              >
                <MoreVerticalIcon />
                <span className="sr-only">Open menu</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-32">
              <ClientEdit prop={row.original.id} />
              <DropdownMenuSeparator />
              <ClientDelete prop={row.original.id} />
            </DropdownMenuContent>
          </DropdownMenu>
        ),
      },
    ],
    [],
  );

  return (
    <ResourceContextProvider value="auto-service/clients">
      <CommonList>
        <CommonTableList
          columns={columns}
          filterSearch="name"
          create={<ClientCreate />}
        />
      </CommonList>
    </ResourceContextProvider>
  );
};

export default AutoClientsList;
